import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetBrowserIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4268 38.6601C14.3225 38.7992 16.7188 38.8 20 38.8C23.2812 38.8 25.6775 38.7992 27.5732 38.6601C29.457 38.5217 30.7518 38.2515 31.8429 37.7604C34.4721 36.5771 36.5771 34.4721 37.7604 31.8429C38.2515 30.7518 38.5217 29.457 38.6601 27.5732C38.7992 25.6775 38.8 23.2812 38.8 20C38.8 16.7188 38.7992 14.3225 38.6601 12.4268C38.5217 10.543 38.2515 9.2482 37.7604 8.15713C36.5771 5.5279 34.4721 3.4229 31.8429 2.23958C30.7518 1.74853 29.457 1.47825 27.5732 1.33994C25.6775 1.20075 23.2812 1.2 20 1.2C16.7188 1.2 14.3225 1.20075 12.4268 1.33994C10.543 1.47825 9.2482 1.74853 8.15713 2.23958C5.5279 3.4229 3.4229 5.5279 2.23958 8.15713C1.74853 9.2482 1.47825 10.543 1.33994 12.4268C1.20075 14.3225 1.2 16.7188 1.2 20C1.2 23.2812 1.20075 25.6775 1.33994 27.5732C1.47825 29.457 1.74853 30.7518 2.23958 31.8429C3.4229 34.4721 5.5279 36.5771 8.15713 37.7604C9.2482 38.2515 10.543 38.5217 12.4268 38.6601ZM1.1453 7.66463C0 10.2094 0 13.4729 0 20C0 26.5271 0 29.7906 1.1453 32.3354C2.44896 35.232 4.76803 37.551 7.66463 38.8547C10.2094 40 13.4729 40 20 40C26.5271 40 29.7906 40 32.3354 38.8547C35.232 37.551 37.551 35.232 38.8547 32.3354C40 29.7906 40 26.5271 40 20C40 13.4729 40 10.2094 38.8547 7.66463C37.551 4.76803 35.232 2.44896 32.3354 1.1453C29.7906 0 26.5271 0 20 0C13.4729 0 10.2094 0 7.66463 1.1453C4.76803 2.44896 2.44896 4.76803 1.1453 7.66463Z",
			fill: "#E7E8E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 32.5C26.9036 32.5 32.5 26.9036 32.5 20C32.5 13.0964 26.9036 7.5 20 7.5C13.0964 7.5 7.5 13.0964 7.5 20C7.5 26.9036 13.0964 32.5 20 32.5ZM20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34Z",
			fill: "#6B7070"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32 15.75L8 15.75L8 14.25L32 14.25L32 15.75Z",
			fill: "#6B7070"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32 25.75L8 25.75L8 24.25L32 24.25L32 25.75Z",
			fill: "#6B7070"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.6003 6.55051C19.8486 6.88207 19.7811 7.35212 19.4495 7.60039C18.2466 8.50113 14.75 12.3362 14.75 20C14.75 27.6639 18.2466 31.499 19.4495 32.3997C19.7811 32.648 19.8486 33.118 19.6003 33.4496C19.3521 33.7811 18.882 33.8487 18.5505 33.6004C16.9756 32.4211 13.25 28.1442 13.25 20C13.25 11.8559 16.9756 7.57896 18.5505 6.3997C18.882 6.15143 19.3521 6.21894 19.6003 6.55051Z",
			fill: "#6B7070"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.3997 33.4495C20.1514 33.1179 20.2189 32.6479 20.5505 32.3996C21.7534 31.4989 25.25 27.6638 25.25 20C25.25 12.3361 21.7534 8.50104 20.5505 7.6003C20.2189 7.35203 20.1514 6.88198 20.3997 6.55042C20.6479 6.21885 21.118 6.15134 21.4495 6.39961C23.0244 7.57887 26.75 11.8558 26.75 20C26.75 28.1441 23.0244 32.421 21.4495 33.6003C21.118 33.8486 20.6479 33.7811 20.3997 33.4495Z",
			fill: "#6B7070"
		})
	]
});
export default SvgAssetBrowserIconOl;
